import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Nav from "./Nav";
import axios from "axios";
import { link } from "./url";

const Viewcustomer = () => {
  const nav = useNavigate();
  const { state } = useLocation();
  const [cust, setCust] = useState([]);
  const [sales, setSales] = useState([]);

  useEffect(() => {
    axios
      .post(link + "salman/vieweachcustomer", { cid: state })
      .then((response) => {
        setCust(response.data.customer);
        setSales(response.data.sales);
      });
  }, [state]);

  const viewbill = (e) => {
    nav("/viewsales", { state: e });
  };

  return (
    <>
      <Nav />
      <div className="container mt-5 pt-5">
        <h2 className="mb-4 text-center">Customer Profile</h2>

        {/* Customer Details Card */}
        <div className="card shadow-lg mb-4">
          <div className="card-header bg-primary text-white">
            <h5 className="mb-0">Customer Details</h5>
          </div>
          <div className="card-body">
            {cust.length > 0 ? (
              <table className="table table-bordered table-striped mb-0">
                <thead className="table-light">
                  <tr>
                    <th>CID</th>
                    <th>Name</th>
                    <th>Area</th>
                    <th>Mobile</th>
                  </tr>
                </thead>
                <tbody>
                  {cust.map((d) => (
                    <tr key={d[0]}>
                      <td>{d[0]}</td>
                      <td>{d[1]}</td>
                      <td>{d[2]}</td>
                      <td>{d[3]}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <p className="text-muted">No customer details found.</p>
            )}
          </div>
        </div>

        {/* Sales History Card */}
        <div className="card shadow-lg">
          <div className="card-header bg-success text-white">
            <h5 className="mb-0">Sales History</h5>
          </div>
          <div className="card-body">
            {sales.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-hover table-striped">
                  <thead className="table-light">
                    <tr>
                      <th>SID</th>
                      <th>Product</th>
                      <th>Price</th>
                      <th>Sales Date</th>
                      <th>Mode</th>
                      <th>Date</th>
                      <th>Balance</th>
                      <th>Next Date</th>
                      <th>Close Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sales.map((d) => (
                      <tr key={d[0]}>
                        <td>
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => viewbill(d)}
                          >
                            {d[0]}
                          </button>
                        </td>
                        <td>{d[2]}</td>
                        <td>₹{d[3]}</td>
                        <td>{d[4]}</td>
                        <td>{d[5]}</td>
                        <td>{d[6]}</td>
                        <td>{d[7]}</td>
                        <td>{d[8]}</td>
                        <td>{d[10]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <p className="text-muted">No sales records available.</p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Viewcustomer;
